import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { TextField, Typography } from '@mui/material';

export default function SurveyQuestion({
  stepTwo,
  question,
  setFirstinput,
  setSecondinput,
  setThirdinput,
  setFirstinputTop,
  setSecondinputTop,
  setThirdinputTop,
  setFirstOption,
  setSecondOption,
  setThirdOption,
  firstInput,
  secondInput,
  thirdInput,
  firstOption,
  secondOption,
  thirdOption,
  selected,
}) {
  const hanldeChangeTop = (e) => {
    question.id === 1 && setFirstinputTop(e.target.value);
    question.id === 2 && setSecondinputTop(e.target.value);
    question.id === 3 && setThirdinputTop(e.target.value);
  };
  const hanldeChange = (e) => {
    question.id === 1 && setFirstinput(e.target.value);
    question.id === 2 && setSecondinput(e.target.value);
    question.id === 3 && setThirdinput(e.target.value);
  };
  const handleOption = (e, option) => {
    question.id === 1 && setFirstOption(option.option);
    question.id === 2 && setSecondOption(option.option);
    question.id === 3 && setThirdOption(option.option);
  };

  return (
    <div className="SurveyQuestionconainer">
      <div className="sqRight">
        <div className="sqOptions">
          <FormControl>
            <FormLabel
              style={{ fontSize: '24px', color: '#000', marginBottom: '20px' }}
              id="demo-radio-buttons-group-label"
            >
              {question?.question}
            </FormLabel>
            {(selected === 'bottom' || stepTwo === 1) && (
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                {question?.options.map((option, _) => (
                  <>
                    {option.input ? (
                      <>
                        {(stepTwo === 1 || selected === 'bottom') && (
                          <div
                            style={{
                              order:
                                stepTwo === 1 || selected === 'bottom' ? -1 : 0,
                            }}
                          >
                            <TextField
                              onChange={hanldeChange}
                              sx={{ width: '100%', backgroundColor: '#fff' }}
                              placeholder="Enter the reason why you gave low score for this?"
                              variant="outlined"
                            />
                            <Typography className="!my-4">
                              OR choose one reason from the three options
                            </Typography>
                          </div>
                        )}
                      </>
                    ) : (
                      <FormControlLabel
                        sx={{
                          order:
                            ((question.id === 1 && firstOption === 'Other') ||
                              (question.id === 2 && secondOption === 'Other') ||
                              (question.id === 3 && thirdOption === 'Other')) &&
                            (stepTwo === 1 || selected === 'bottom') &&
                            option?.option === 'Other'
                              ? -1
                              : 0,
                        }}
                        disabled={
                          (question.id === 1 && firstInput ? true : false) ||
                          (question.id === 2 && secondInput ? true : false) ||
                          (question.id === 3 && thirdInput ? true : false)
                        }
                        onChange={(e) => handleOption(e, option)}
                        key={_}
                        value={option?.value}
                        control={<Radio />}
                        label={option?.option}
                      />
                    )}
                  </>
                ))}
              </RadioGroup>
            )}
            {selected === 'top' && stepTwo !== 1 && (
              <TextField
                style={{ marginTop: '10px' }}
                onChange={hanldeChangeTop}
                sx={{ width: '100%', backgroundColor: '#fff' }}
                placeholder="Please tell us why you scored this question high."
                variant="outlined"
              />
            )}
          </FormControl>
        </div>
      </div>
    </div>
  );
}
